import { render, staticRenderFns } from "./TemplateDesign.vue?vue&type=template&id=3267bb50"
import script from "./TemplateDesign.vue?vue&type=script&lang=ts"
export * from "./TemplateDesign.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports